export default {
    title: 'This search agent is part of the work space'
}
